import {
  SUCCESS_BACKGROUND,
  SUCCESS_COLOR,
  WARNING_BACKGROUND,
  WARNING_COLOR
} from "../../../themes/themeConfigurator";

const tabletEdgeMaxMD = 1100;
const tabletEdgeMaxSM = 720;

const styles = (theme) => ({
  stickyHeadline: {
    position: 'sticky',
    top: 'var(--sticky-header-top, -12px)', // padding of grid item
    background: '#fff',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      top: 'var(--sticky-header-top, 0px)',
    }
  },
  stepName: {
    fontSize: 24,
    fontFamily: 'Roboto-Bold',
    lineHeight: '32px',
  },
  filterSelect: {
    height: 36,
    margin: 0,
  },
  totalValueChip: {
    background: 'rgba(131, 138, 147, 0.12)',
    borderRadius: 8,
    padding: '6px 12px',
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
    [theme.breakpoints.down('md')]: {
      padding: '6px',
      fontSize: 14,
    },

    '&.green': {
      color: SUCCESS_COLOR,
      background: SUCCESS_BACKGROUND,
    },
    '&.orange': {
      color: WARNING_COLOR,
      background: WARNING_BACKGROUND,
    }
  },
  categoryName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
  },
  categoryItemsCount: {
    color: 'rgba(15, 23, 42, 0.60)',
    fontSize: 12,
  },
  categoryTotal: {
    fontSize: 12,
  },
  addBtnShort: {
    [theme.breakpoints.up(tabletEdgeMaxMD)]: {
      display: 'none',
    },
    [theme.breakpoints.between(tabletEdgeMaxSM, 'sm')]: {
      display: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    }
  },
  addBtnLong: {
    [theme.breakpoints.between('md', tabletEdgeMaxMD)]: {
      display: 'none',
    },
    [theme.breakpoints.between('sm', tabletEdgeMaxSM)]: {
      display: 'none',
    }
  }
});

export default styles;